import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import style from './footer.sass'

class Footer extends Component {
  render() {
    return(
      <footer styleName='wrapper'>
        <p>© {new Date().getFullYear()}. All rights reserved. | Contact us at <a href='mailto:support@algoriz.com'>support@algoriz.com</a> if you have any comments or questions.</p>
        <div styleName='links'>
          <Link to='/terms-and-conditions/'>Terms of Service</Link>
          <Link to='/privacy-policy/'>Privacy Policy</Link>
        </div>
      </footer>
    )
  }
}

export default Footer
